import { generateEventId } from "./session";

const CART_STORAGE_PREFIX = "meucontroleai:storefront-analytics:cart:";

function key(merchantId: string): string {
  return `${CART_STORAGE_PREFIX}${merchantId}`;
}

/** Cart id of the open bag, or null when this browser has not started one. */
export function readCartId(merchantId: string): string | null {
  try {
    return localStorage.getItem(key(merchantId));
  } catch {
    return null;
  }
}

/** Stable cart id for the open bag. Created on the first item. */
export function ensureCartId(merchantId: string): string {
  const existing = readCartId(merchantId);
  if (existing) return existing;
  const created = generateEventId();
  try {
    localStorage.setItem(key(merchantId), created);
  } catch {
    return created;
  }
  return created;
}

/** Drops the open cart id so the next item starts a new cart. */
export function rotateCartId(merchantId: string): void {
  try {
    localStorage.removeItem(key(merchantId));
  } catch {
    return;
  }
}
